import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from './reducers/root-reducer';
import thunk, { ThunkMiddleware } from 'redux-thunk';
import * as Sentry from '@sentry/react';

declare global {
	interface Window {
		__REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
	}
}

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
	// Optionally pass options
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
	rootReducer,
	composeEnhancers(applyMiddleware(thunk as ThunkMiddleware<any, any>), sentryReduxEnhancer),
);


export type RootState = ReturnType<typeof rootReducer>;
export default store;
